export default "__VITE_ASSET__5fa23e60__"